import React, { useState, useMemo } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import StrianoLogo from "../components/StrianoLogo";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "../lib/api";
import { KeyRound, CheckCircle2 } from "lucide-react";

import { API_BASE } from "../lib/api";
const BACKEND = API_BASE.replace(/\/api$/, "");

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = useMemo(() => params.get("token") || "", [params]);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error("Link non valido: token mancante"); return; }
    if (password.length < 6) { toast.error("Password minimo 6 caratteri"); return; }
    if (password !== confirm) { toast.error("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await axios.post(`${BACKEND}/api/auth/reset-password`, { token, password });
      setDone(true);
      toast.success("Password aggiornata");
      setTimeout(() => nav("/login"), 1800);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#090D16] bg-grid flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="inline-flex items-center justify-center mb-3">
            <StrianoLogo variant="full" size={120}/>
          </div>
          <div className="text-xs uppercase tracking-widest text-slate-500 font-mono-num">Reset password autista</div>
        </div>

        {done ? (
          <div data-testid="reset-success" className="rounded-2xl border border-emerald-500/40 bg-emerald-500/10 p-8 text-center space-y-3">
            <CheckCircle2 className="mx-auto text-emerald-400" size={48}/>
            <div className="font-display text-xl font-extrabold text-white">Password aggiornata</div>
            <div className="text-slate-300 text-sm">Reindirizzamento al login...</div>
          </div>
        ) : (
          <form onSubmit={submit} className="rounded-2xl border border-slate-800 bg-slate-950/80 backdrop-blur-md p-8 space-y-5 shadow-2xl">
            <div className="flex items-center gap-2 text-amber-400">
              <KeyRound size={18}/>
              <div className="text-xs uppercase tracking-widest font-mono-num">Imposta nuova password</div>
            </div>
            <div>
              <Label className="text-slate-400 text-xs uppercase tracking-widest">Nuova password</Label>
              <Input data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} className="mt-1.5 bg-slate-900 border-slate-800 text-white" placeholder="min. 6 caratteri" />
            </div>
            <div>
              <Label className="text-slate-400 text-xs uppercase tracking-widest">Conferma password</Label>
              <Input data-testid="reset-password-confirm" type="password" required minLength={6} value={confirm} onChange={(e)=>setConfirm(e.target.value)} className="mt-1.5 bg-slate-900 border-slate-800 text-white" />
            </div>
            <Button data-testid="reset-submit" type="submit" disabled={loading || !token} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-bold uppercase tracking-wide">
              {loading ? "Aggiornamento..." : "Aggiorna password"}
            </Button>
            {!token && (
              <div className="text-xs text-rose-400 text-center">Link non valido: token mancante. Richiedi un nuovo reset dal login.</div>
            )}
            <div className="text-xs text-slate-500 text-center pt-2">
              <Link data-testid="back-to-login" to="/login" className="text-amber-400 hover:text-amber-300 font-semibold">← Torna al login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
